var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWomanLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M198.88 13.4272H21.1201C16.26 13.4272 12.3201 17.3671 12.3201 22.2272V130.291C12.3201 135.151 16.26 139.091 21.1201 139.091H198.88C203.74 139.091 207.68 135.151 207.68 130.291V22.2272C207.68 17.3671 203.74 13.4272 198.88 13.4272Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.902 13.8232H20.79C16.1243 13.8232 12.342 17.6055 12.342 22.2712V129.177C12.342 133.842 16.1243 137.625 20.79 137.625H198.902C203.568 137.625 207.35 133.842 207.35 129.177V22.2712C207.35 17.6055 203.568 13.8232 198.902 13.8232Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.342 116.989H207.35",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.342 96.3599H207.35",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.342 75.7241H207.35",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.342 55.0879H207.35",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.342 34.4595H207.35",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.849 13.8232V137.625",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.347 13.8232V137.625",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.846 13.8232V137.625",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3447 13.8232V137.625",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8433 13.8232V137.625",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.496 200.691L47.4687 150.018C41.426 145.933 42.0127 136.855 48.532 133.584L84.4947 115.551C87.6113 113.989 91.3293 114.253 94.1893 116.233L162.287 163.284C167.655 166.995 167.801 174.878 162.565 178.779L133.533 200.435C130.284 202.862 125.855 202.965 122.489 200.691H122.496Z",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.156 149.989C177.445 153.113 175.604 155.856 172.979 157.696L141.988 179.432C136.319 183.048 129.067 183.04 123.405 179.41L48.0481 131.135C44.0074 128.546 41.6094 124.044 41.7194 119.248L41.7781 116.732L86.8781 96.0449C91.6228 93.8669 97.1521 94.2482 101.552 97.0642L175.934 144.577C177.745 145.736 178.633 147.899 178.156 149.996V149.989Z",
    fill: "#AFAFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.174 141.504C175.949 142.524 179.417 147.158 177.701 148.273L135.843 175.458C133.21 177.269 129.749 177.32 127.065 175.59L44.1174 122.078C40.8028 119.937 41.0741 115.002 44.6014 113.242L84.9641 93.075C88.6821 91.2197 93.0894 91.4177 96.6241 93.603L174.181 141.519L174.174 141.504Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.994 141.593C171.563 142.495 171.629 144.746 170.104 145.736L132.968 169.855C130.629 171.461 127.556 171.505 125.18 169.973L51.5901 122.496C48.6495 120.597 48.8915 116.219 52.0228 114.657L87.8315 96.7638C91.1241 95.1138 95.0402 95.2898 98.1788 97.2332L170.001 141.607L169.994 141.593Z",
    fill: "#07A587"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.869 163.072L138.439 157.139C139.957 156.201 139.642 153.905 137.926 153.414C130.277 151.207 122.056 152.204 115.163 156.186L126.735 163.087C127.395 163.483 128.224 163.475 128.876 163.072H128.869Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.601 153.538L163.379 142.12C163.995 141.768 163.995 140.881 163.379 140.529L151.279 133.54C150.795 133.262 150.187 133.467 149.967 133.98L142.274 152.387C142.061 152.893 142.34 153.472 142.868 153.626C142.868 153.626 142.875 153.626 142.883 153.626C143.125 153.692 143.381 153.663 143.601 153.538Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.532 130.571L139.135 151.61C134.178 150.033 129.719 149.799 124.623 150.671L132.726 130.71L144.503 128.818L147.525 130.563L147.532 130.571Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.919 151.478L123.86 144.232L101.009 141.526L97.1741 145.794L113.095 154.983C115.544 153.487 118.147 152.292 120.919 151.47V151.478Z",
    fill: "#27DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.593 123.677L142.736 127.799L133.298 129.324L135.593 123.677Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1835 124.682C89.1735 124.11 90.7868 124.11 91.7842 124.682C92.7742 125.254 92.7742 126.185 91.7842 126.757C90.7942 127.329 89.1808 127.329 88.1835 126.757C87.1862 126.185 87.1935 125.254 88.1835 124.682Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.191 130.857L93.852 126.669C93.478 127.52 92.84 127.711 91.3586 128.033L101.222 139.312L124.733 142.099L129.199 130.857H129.191Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.398 120.194L109.802 126.486L93.7349 124.579C93.4342 124.235 92.9649 123.941 92.3562 123.692L94.5562 118.075L112.391 120.187L112.398 120.194Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.851 122.093L130.086 128.891L112.486 126.809L115.258 120.003L132.851 122.093Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.551 120.186L100.393 103.349L95.3481 116.124L129.551 120.186Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8461 127.835L98.6114 140.148L94.7761 144.416L73.9641 132.404L86.8048 127.358C87.1348 127.556 87.4794 127.725 87.8388 127.842L87.8461 127.835Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5074 114.503L97.8121 103.591C98.1347 102.77 97.834 101.831 97.0934 101.362L94.0867 99.4332C93.5294 99.0739 92.8181 99.0446 92.2241 99.3599L72.5414 109.788C70.95 110.631 71.3827 113.015 73.1647 113.249L91.5494 115.655C92.3854 115.765 93.1921 115.288 93.5074 114.503Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8827 113.638L56.3788 119.145C55.3008 119.769 55.3081 121.323 56.3788 121.939L68.8748 129.155C69.3001 129.405 69.8134 129.441 70.2754 129.258L82.4561 124.455C82.8741 124.286 83.2408 123.963 83.3801 123.538C83.5194 123.113 83.8934 122.651 84.5974 122.24C85.1914 121.895 85.8954 121.705 86.6728 121.617C87.2594 121.551 87.7581 121.155 87.9708 120.605L88.9827 118.031C89.3714 117.041 88.7188 115.955 87.6628 115.838L66.8728 113.425C66.5281 113.389 66.1761 113.455 65.8754 113.631L65.8827 113.638Z",
    fill: "#8FFFD1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0273 115.713V111.819L103.041 112.531V116.425L97.0273 115.713Z",
    fill: "#27DEBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.041 112.531L104.28 109.062V113.359L103.041 116.425V112.531Z",
    fill: "#27DEBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.28 109.062L98.3913 108.351L97.0273 111.819L103.041 112.531L104.28 109.062Z",
    fill: "#27DEBF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M97.0273 115.713V111.819L103.041 112.531V116.425L97.0273 115.713Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M103.041 112.531L104.28 109.062V113.359L103.041 116.425V112.531Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M104.28 109.062L98.3913 108.351L97.0273 111.819L103.041 112.531L104.28 109.062Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.973 124.029V122.284L106.986 122.995V124.74L100.973 124.029Z",
    fill: "#27DEBF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.986 122.995L108.057 119.988V122.137L106.986 124.74V122.995Z",
    fill: "#27DEBF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.057 119.988L102.175 119.277L100.973 122.284L106.986 122.995L108.057 119.988Z",
    fill: "#27DEBF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100.973 124.029V122.284L106.986 122.995V124.74L100.973 124.029Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M106.986 122.995L108.057 119.988V122.137L106.986 124.74V122.995Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M108.057 119.988L102.175 119.277L100.973 122.284L106.986 122.995L108.057 119.988Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.552 146.99V143.096L118.573 143.807V147.701L112.552 146.99Z",
    fill: "#27DEBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.573 143.807L119.812 140.346V144.636L118.573 147.701V143.807Z",
    fill: "#27DEBF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.812 140.346L113.923 139.634L112.552 143.096L118.573 143.807L119.812 140.346Z",
    fill: "#27DEBF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.552 146.99V143.096L118.573 143.807V147.701L112.552 146.99Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M118.573 143.807L119.812 140.346V144.636L118.573 147.701V143.807Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M119.812 140.346L113.923 139.634L112.552 143.096L118.573 143.807L119.812 140.346Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.449 117.466V116.028L115.493 116.388V117.825L112.449 117.466Z",
    fill: "#27DEBF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.493 116.388L116.124 114.635V116.278L115.493 117.825V116.388Z",
    fill: "#27DEBF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.123 114.635L113.146 114.276L112.449 116.029L115.493 116.388L116.123 114.635Z",
    fill: "#27DEBF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.449 117.466V116.028L115.493 116.388V117.825L112.449 117.466Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M115.493 116.388L116.124 114.635V116.278L115.493 117.825V116.388Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M116.123 114.635L113.146 114.276L112.449 116.029L115.493 116.388L116.123 114.635Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2588 110.697V108.614L94.6881 109.135V111.225L90.2588 110.697Z",
    fill: "#27DEBF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6882 109.135L95.6049 106.583V108.966L94.6882 111.225V109.135Z",
    fill: "#27DEBF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6048 106.583L91.2708 106.062L90.2588 108.614L94.6881 109.135L95.6048 106.583Z",
    fill: "#27DEBF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.2588 110.697V108.614L94.6881 109.135V111.225L90.2588 110.697Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M94.6882 109.135L95.6049 106.583V108.966L94.6882 111.225V109.135Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M95.6048 106.583L91.2708 106.062L90.2588 108.614L94.6881 109.135L95.6048 106.583Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.977 125.591V123.729L116.93 124.198V126.061L112.977 125.591Z",
    fill: "#27DEBF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.93 124.198L117.744 121.924V124.044L116.93 126.06V124.198Z",
    fill: "#27DEBF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.744 121.924L113.879 121.455L112.977 123.728L116.93 124.198L117.744 121.924Z",
    fill: "#27DEBF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.977 125.591V123.729L116.93 124.198V126.061L112.977 125.591Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M116.93 124.198L117.744 121.924V124.044L116.93 126.06V124.198Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M117.744 121.924L113.879 121.455L112.977 123.728L116.93 124.198L117.744 121.924Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M95.062 123.369V121.455L99.1247 121.939V123.853L95.062 123.369Z",
    fill: "#27DEBF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1248 121.939L99.9681 119.592V121.778L99.1248 123.853V121.939Z",
    fill: "#27DEBF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.968 119.592L95.986 119.116L95.062 121.455L99.1247 121.939L99.968 119.592Z",
    fill: "#27DEBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M95.062 123.369V121.455L99.1247 121.939V123.853L95.062 123.369Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M99.1248 121.939L99.9681 119.592V121.778L99.1248 123.853V121.939Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M99.968 119.592L95.986 119.116L95.062 121.455L99.1247 121.939L99.968 119.592Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.089 126.178V124.322L122.041 124.784V126.647L118.089 126.178Z",
    fill: "#27DEBF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M122.041 124.784L122.855 122.511V124.637L122.041 126.647V124.784Z",
    fill: "#27DEBF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 122.511L118.991 122.049L118.089 124.322L122.041 124.784L122.855 122.511Z",
    fill: "#27DEBF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M118.089 126.178V124.322L122.041 124.784V126.647L118.089 126.178Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122.041 124.784L122.855 122.511V124.637L122.041 126.647V124.784Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M122.855 122.511L118.991 122.049L118.089 124.322L122.041 124.784L122.855 122.511Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 126.772V124.909L127.145 125.379V127.234L123.2 126.772Z",
    fill: "#27DEBF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.145 125.378L127.959 123.098V125.224L127.145 127.234V125.378Z",
    fill: "#27DEBF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M127.959 123.098L124.095 122.636L123.2 124.909L127.145 125.378L127.959 123.098Z",
    fill: "#27DEBF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M123.2 126.772V124.909L127.145 125.379V127.234L123.2 126.772Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M127.145 125.378L127.959 123.098V125.224L127.145 127.234V125.378Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M127.959 123.098L124.095 122.636L123.2 124.909L127.145 125.378L127.959 123.098Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9441 120.56V118.698L79.8894 119.167V121.03L75.9441 120.56Z",
    fill: "#27DEBF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8894 119.167L80.7034 116.894V119.013L79.8894 121.03V119.167Z",
    fill: "#27DEBF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7034 116.894L76.8388 116.424L75.9441 118.698L79.8894 119.167L80.7034 116.894Z",
    fill: "#27DEBF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M75.9441 120.56V118.698L79.8894 119.167V121.03L75.9441 120.56Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M79.8894 119.167L80.7034 116.894V119.013L79.8894 121.03V119.167Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.7034 116.894L76.8388 116.424L75.9441 118.698L79.8894 119.167L80.7034 116.894Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0481 121.147V119.292L85.0008 119.754V121.617L81.0481 121.147Z",
    fill: "#27DEBF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0007 119.754L85.8147 117.48V119.607L85.0007 121.616V119.754Z",
    fill: "#27DEBF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8148 117.481L81.9501 117.011L81.0481 119.292L85.0008 119.754L85.8148 117.481Z",
    fill: "#27DEBF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.0481 121.147V119.292L85.0008 119.754V121.617L81.0481 121.147Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M85.0007 119.754L85.8147 117.48V119.607L85.0007 121.616V119.754Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M85.8148 117.481L81.9501 117.011L81.0481 119.292L85.0008 119.754L85.8148 117.481Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1594 121.741V119.878L90.1048 120.34V122.203L86.1594 121.741Z",
    fill: "#27DEBF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1047 120.34L90.9187 118.067V120.194L90.1047 122.203V120.34Z",
    fill: "#27DEBF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9188 118.067L87.0541 117.605L86.1594 119.878L90.1048 120.34L90.9188 118.067Z",
    fill: "#27DEBF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M86.1594 121.741V119.878L90.1048 120.34V122.203L86.1594 121.741Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M90.1047 120.34L90.9187 118.067V120.194L90.1047 122.203V120.34Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M90.9188 118.067L87.0541 117.605L86.1594 119.878L90.1048 120.34L90.9188 118.067Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M137.148 114.591V113.484L140.499 113.873V114.98L137.148 114.591Z",
    fill: "#27DEBF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M137.148 114.591V113.484L140.499 113.873V114.98L137.148 114.591Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M140.499 113.872L140.983 112.442V113.784L140.499 114.98V113.872Z",
    fill: "#27DEBF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M140.499 113.872L140.983 112.442V113.784L140.499 114.98V113.872Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M140.983 112.442L137.713 112.046L137.148 113.484L140.499 113.872L140.983 112.442Z",
    fill: "#27DEBF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M140.983 112.442L137.713 112.046L137.148 113.484L140.499 113.872L140.983 112.442Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M113.41 138.014V136.151L117.363 136.621V138.483L113.41 138.014Z",
    fill: "#27DEBF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M117.363 136.621L118.177 134.34V136.467L117.363 138.483V136.621Z",
    fill: "#27DEBF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M118.177 134.34L114.312 133.878L113.41 136.151L117.363 136.621L118.177 134.34Z",
    fill: "#27DEBF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M113.41 138.014V136.151L117.363 136.621V138.483L113.41 138.014Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M117.363 136.621L118.177 134.34V136.467L117.363 138.483V136.621Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M118.177 134.34L114.312 133.878L113.41 136.151L117.363 136.621L118.177 134.34Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M118.338 138.6V136.738L122.291 137.207V139.07L118.338 138.6Z",
    fill: "#27DEBF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M122.291 137.207L123.105 134.926V137.053L122.291 139.07V137.207Z",
    fill: "#27DEBF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M123.105 134.926L119.24 134.464L118.338 136.738L122.291 137.207L123.105 134.926Z",
    fill: "#27DEBF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M118.338 138.6V136.738L122.291 137.207V139.07L118.338 138.6Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122.291 137.207L123.105 134.926V137.053L122.291 139.07V137.207Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M123.105 134.926L119.24 134.464L118.338 136.738L122.291 137.207L123.105 134.926Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M100.936 144.247V142.392L104.881 142.854V144.716L100.936 144.247Z",
    fill: "#27DEBF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.881 142.853L105.695 140.58V142.707L104.881 144.716V142.853Z",
    fill: "#27DEBF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M105.695 140.58L101.831 140.111L100.936 142.392L104.881 142.854L105.695 140.58Z",
    fill: "#27DEBF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100.936 144.247V142.392L104.881 142.854V144.716L100.936 144.247Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M104.881 142.853L105.695 140.58V142.707L104.881 144.716V142.853Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M105.695 140.58L101.831 140.111L100.936 142.392L104.881 142.854L105.695 140.58Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M105.864 144.834V142.979L109.817 143.441V145.303L105.864 144.834Z",
    fill: "#27DEBF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M109.817 143.44L110.631 141.167V143.294L109.817 145.303V143.44Z",
    fill: "#27DEBF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M110.631 141.167L106.766 140.698L105.864 142.978L109.817 143.44L110.631 141.167Z",
    fill: "#27DEBF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M105.864 144.834V142.979L109.817 143.441V145.303L105.864 144.834Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M109.817 143.44L110.631 141.167V143.294L109.817 145.303V143.44Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M110.631 141.167L106.766 140.698L105.864 142.978L109.817 143.44L110.631 141.167Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M135.835 135.411V133.555L139.781 134.017V135.88L135.835 135.411Z",
    fill: "#27DEBF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M139.781 134.017L140.595 131.744V133.87L139.781 135.88V134.017Z",
    fill: "#27DEBF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M140.595 131.744L136.73 131.274L135.835 133.555L139.781 134.017L140.595 131.744Z",
    fill: "#27DEBF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M135.835 135.411V133.555L139.781 134.017V135.88L135.835 135.411Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M139.781 134.017L140.595 131.744V133.87L139.781 135.88V134.017Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M140.595 131.744L136.73 131.274L135.835 133.555L139.781 134.017L140.595 131.744Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M134.281 139.246V137.391L138.233 137.853V139.715L134.281 139.246Z",
    fill: "#27DEBF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M138.233 137.852L139.047 135.579V137.706L138.233 139.715V137.852Z",
    fill: "#27DEBF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M139.047 135.579L135.183 135.11L134.281 137.391L138.233 137.853L139.047 135.579Z",
    fill: "#27DEBF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M134.281 139.246V137.391L138.233 137.853V139.715L134.281 139.246Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M138.233 137.852L139.047 135.579V137.706L138.233 139.715V137.852Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M139.047 135.579L135.183 135.11L134.281 137.391L138.233 137.853L139.047 135.579Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M132.733 143.081V141.226L136.686 141.688V143.55L132.733 143.081Z",
    fill: "#27DEBF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M136.686 141.687L137.5 139.414V141.541L136.686 143.55V141.687Z",
    fill: "#27DEBF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 139.414L133.635 138.945L132.733 141.225L136.686 141.687L137.5 139.414Z",
    fill: "#27DEBF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M132.733 143.081V141.226L136.686 141.688V143.55L132.733 143.081Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M136.686 141.687L137.5 139.414V141.541L136.686 143.55V141.687Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M137.5 139.414L133.635 138.945L132.733 141.225L136.686 141.687L137.5 139.414Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M131.186 146.916V145.061L135.131 145.523V147.386L131.186 146.916Z",
    fill: "#27DEBF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M135.131 145.523L135.953 143.25V145.376L135.131 147.386V145.523Z",
    fill: "#27DEBF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M135.953 143.25L132.081 142.78L131.186 145.061L135.131 145.523L135.953 143.25Z",
    fill: "#27DEBF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M131.186 146.916V145.061L135.131 145.523V147.386L131.186 146.916Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M135.131 145.523L135.953 143.25V145.376L135.131 147.386V145.523Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M135.953 143.25L132.081 142.78L131.186 145.061L135.131 145.523L135.953 143.25Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M129.133 134.633V132.771L133.078 133.24V135.103L129.133 134.633Z",
    fill: "#27DEBF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M133.078 133.24L133.892 130.966V133.086L133.078 135.102V133.24Z",
    fill: "#27DEBF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M133.892 130.966L130.027 130.497L129.133 132.77L133.078 133.24L133.892 130.966Z",
    fill: "#27DEBF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M129.133 134.633V132.771L133.078 133.24V135.103L129.133 134.633Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M133.078 133.24L133.892 130.966V133.086L133.078 135.102V133.24Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M133.892 130.966L130.027 130.497L129.133 132.77L133.078 133.24L133.892 130.966Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M127.578 138.469V136.606L131.531 137.075V138.938L127.578 138.469Z",
    fill: "#27DEBF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M131.531 137.075L132.345 134.802V136.921L131.531 138.938V137.075Z",
    fill: "#27DEBF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M132.345 134.802L128.48 134.333L127.578 136.606L131.531 137.075L132.345 134.802Z",
    fill: "#27DEBF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.578 138.469V136.606L131.531 137.075V138.938L127.578 138.469Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M131.531 137.075L132.345 134.802V136.921L131.531 138.938V137.075Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M132.345 134.802L128.48 134.333L127.578 136.606L131.531 137.075L132.345 134.802Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M126.031 142.304V140.441L129.983 140.91V142.773L126.031 142.304Z",
    fill: "#27DEBF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M129.983 140.91L130.797 138.637V140.756L129.983 142.773V140.91Z",
    fill: "#27DEBF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M130.797 138.637L126.933 138.167L126.031 140.441L129.983 140.91L130.797 138.637Z",
    fill: "#27DEBF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M126.031 142.304V140.441L129.983 140.91V142.773L126.031 142.304Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M129.983 140.91L130.797 138.637V140.756L129.983 142.773V140.91Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M130.797 138.637L126.933 138.167L126.031 140.441L129.983 140.91L130.797 138.637Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M124.483 146.139V144.276L128.429 144.746V146.608L124.483 146.139Z",
    fill: "#27DEBF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M128.429 144.746L129.243 142.465V144.592L128.429 146.608V144.746Z",
    fill: "#27DEBF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M129.243 142.465L125.378 142.003L124.483 144.276L128.429 144.746L129.243 142.465Z",
    fill: "#27DEBF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M124.483 146.139V144.276L128.429 144.746V146.608L124.483 146.139Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M128.429 144.746L129.243 142.465V144.592L128.429 146.608V144.746Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M129.243 142.465L125.378 142.003L124.483 144.276L128.429 144.746L129.243 142.465Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M142.377 141.651V140.185L145.486 140.551V142.018L142.377 141.651Z",
    fill: "#27DEBF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M145.486 140.551L146.124 138.762V140.434L145.486 142.018V140.551Z",
    fill: "#27DEBF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M146.124 138.762L143.088 138.395L142.377 140.184L145.486 140.551L146.124 138.762Z",
    fill: "#27DEBF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M142.377 141.651V140.185L145.486 140.551V142.018L142.377 141.651Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M145.486 140.551L146.124 138.762V140.434L145.486 142.018V140.551Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M146.124 138.762L143.088 138.395L142.377 140.184L145.486 140.551L146.124 138.762Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M140.822 145.963V144.497L143.931 144.863V146.33L140.822 145.963Z",
    fill: "#27DEBF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M143.931 144.863L144.569 143.074V144.746L143.931 146.33V144.863Z",
    fill: "#27DEBF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M144.569 143.074L141.533 142.707L140.822 144.496L143.931 144.863L144.569 143.074Z",
    fill: "#27DEBF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M140.822 145.963V144.497L143.931 144.863V146.33L140.822 145.963Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M143.931 144.863L144.569 143.074V144.746L143.931 146.33V144.863Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M144.569 143.074L141.533 142.707L140.822 144.496L143.931 144.863L144.569 143.074Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M107.463 137.244V130.27L112.361 130.842V137.816L107.463 137.244Z",
    fill: "#27DEBF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M107.463 137.244V130.27L112.361 130.842V137.816L107.463 137.244Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 130.841L112.999 129.147V136.466L112.361 137.815V130.841Z",
    fill: "#27DEBF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M112.361 130.841L112.999 129.147V136.466L112.361 137.815V130.841Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M112.999 129.148L108.211 128.568L107.463 130.27L112.361 130.842L112.999 129.148Z",
    fill: "#27DEBF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M112.999 129.148L108.211 128.568L107.463 130.27L112.361 130.842L112.999 129.148Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7126 113.799V105.556L85.5286 105.871V114.114L82.7126 113.799Z",
    fill: "#27DEBF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M82.7126 113.799V105.556L85.5286 105.871V114.114L82.7126 113.799Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5286 105.872L86.1666 104.17V112.765L85.5286 114.114V105.872Z",
    fill: "#27DEBF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M85.5286 105.872L86.1666 104.17V112.765L85.5286 114.114V105.872Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1666 104.17L83.4606 103.855L82.7126 105.556L85.5286 105.872L86.1666 104.17Z",
    fill: "#27DEBF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M86.1666 104.17L83.4606 103.855L82.7126 105.556L85.5286 105.872L86.1666 104.17Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8513 113.513V106.238L87.3473 106.4V113.674L85.8513 113.513Z",
    fill: "#27DEBF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M85.8513 113.513V106.238L87.3473 106.4V113.674L85.8513 113.513Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3474 106.399L87.5747 105.659V113.227L87.3474 113.674V106.399Z",
    fill: "#27DEBF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M87.3474 106.399L87.5747 105.659V113.227L87.3474 113.674V106.399Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5747 105.659L86.1813 105.498L85.8513 106.238L87.3473 106.4L87.5747 105.659Z",
    fill: "#27DEBF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M87.5747 105.659L86.1813 105.498L85.8513 106.238L87.3473 106.4L87.5747 105.659Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M101.611 136.547V129.573L106.51 130.145V137.119L101.611 136.547Z",
    fill: "#27DEBF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101.611 136.547V129.573L106.51 130.145V137.119L101.611 136.547Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M106.51 130.145L107.14 128.451V135.769L106.51 137.119V130.145Z",
    fill: "#27DEBF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M106.51 130.145L107.14 128.451V135.769L106.51 137.119V130.145Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M107.14 128.451L102.359 127.872L101.611 129.573L106.51 130.145L107.14 128.451Z",
    fill: "#27DEBF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M107.14 128.451L102.359 127.872L101.611 129.573L106.51 130.145L107.14 128.451Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M88.748 114.591V112.501L93.1774 113.022V115.112L88.748 114.591Z",
    fill: "#27DEBF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1775 113.022L94.0868 110.47V112.853L93.1775 115.112V113.022Z",
    fill: "#27DEBF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0867 110.47L89.7527 109.949L88.748 112.501L93.1774 113.022L94.0867 110.47Z",
    fill: "#27DEBF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M88.748 114.591V112.501L93.1774 113.022V115.112L88.748 114.591Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M93.1775 113.022L94.0868 110.47V112.853L93.1775 115.112V113.022Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M94.0867 110.47L89.7527 109.949L88.748 112.501L93.1774 113.022L94.0867 110.47Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8833 129.551L81.7153 131.377L79.1707 129.925L82.5073 127.997L84.8833 129.551Z",
    fill: "#27DEBF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M84.8833 129.551L81.7153 131.377L79.1707 129.925L82.5073 127.997L84.8833 129.551Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1707 131.429V129.925L81.7153 131.377V132.895L79.1707 131.429Z",
    fill: "#27DEBF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.1707 131.429V129.925L81.7153 131.377V132.895L79.1707 131.429Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8833 129.551V131.069L81.7153 132.895V131.377L84.8833 129.551Z",
    fill: "#27DEBF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M84.8833 129.551V131.069L81.7153 132.895V131.377L84.8833 129.551Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4326 131.641L85.2573 133.467L82.72 132.015L86.0566 130.094L88.4326 131.641Z",
    fill: "#27DEBF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M88.4326 131.641L85.2573 133.467L82.72 132.015L86.0566 130.094L88.4326 131.641Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M82.72 133.526V132.015L85.2573 133.467V134.992L82.72 133.526Z",
    fill: "#27DEBF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M82.72 133.526V132.015L85.2573 133.467V134.992L82.72 133.526Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4327 131.641V133.159L85.2573 134.992V133.467L88.4327 131.641Z",
    fill: "#27DEBF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M88.4327 131.641V133.159L85.2573 134.992V133.467L88.4327 131.641Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0479 133.709L88.8725 135.543L86.3352 134.083L89.6719 132.162L92.0479 133.709Z",
    fill: "#27DEBF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M92.0479 133.709L88.8725 135.543L86.3352 134.083L89.6719 132.162L92.0479 133.709Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3352 135.594V134.083L88.8725 135.543V137.061L86.3352 135.594Z",
    fill: "#27DEBF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M86.3352 135.594V134.083L88.8725 135.543V137.061L86.3352 135.594Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0479 133.709V135.227L88.8726 137.061V135.543L92.0479 133.709Z",
    fill: "#27DEBF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M92.0479 133.709V135.227L88.8726 137.061V135.543L92.0479 133.709Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1814 134.648L94.0134 136.474L91.4688 135.022L94.8054 133.101L97.1814 134.648Z",
    fill: "#27DEBF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M97.1814 134.648L94.0134 136.474L91.4688 135.022L94.8054 133.101L97.1814 134.648Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4688 138.652V135.022L94.0134 136.474V140.119L91.4688 138.652Z",
    fill: "#27DEBF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91.4688 138.652V135.022L94.0134 136.474V140.119L91.4688 138.652Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1814 134.648V138.285L94.0134 140.119V136.474L97.1814 134.648Z",
    fill: "#27DEBF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M97.1814 134.648V138.285L94.0134 140.119V136.474L97.1814 134.648Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2174 126.104L74.7781 127.395L72.2407 125.936L75.8414 124.557L78.2174 126.104Z",
    fill: "#27DEBF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M78.2174 126.104L74.7781 127.395L72.2407 125.936L75.8414 124.557L78.2174 126.104Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2407 127.446V125.936L74.7781 127.395V128.913L72.2407 127.446Z",
    fill: "#27DEBF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M72.2407 127.446V125.936L74.7781 127.395V128.913L72.2407 127.446Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2174 126.104V127.622L74.7781 128.913V127.395L78.2174 126.104Z",
    fill: "#27DEBF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M78.2174 126.104V127.622L74.7781 128.913V127.395L78.2174 126.104Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M83.732 124.007L80.2927 125.29L77.748 123.838L81.3487 122.452L83.732 124.007Z",
    fill: "#27DEBF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M83.732 124.007L80.2927 125.29L77.748 123.838L81.3487 122.452L83.732 124.007Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M77.748 125.342V123.838L80.2927 125.29V126.808L77.748 125.342Z",
    fill: "#27DEBF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M77.748 125.342V123.838L80.2927 125.29V126.808L77.748 125.342Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7321 124.007V125.525L80.2927 126.808V125.29L83.7321 124.007Z",
    fill: "#27DEBF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M83.7321 124.007V125.525L80.2927 126.808V125.29L83.7321 124.007Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M104.595 116.454V114.254L111.027 115.017V117.217L104.595 116.454Z",
    fill: "#27DEBF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M104.595 116.454V114.254L111.027 115.017V117.217L104.595 116.454Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M111.027 115.016L112.384 111.21V113.85L111.027 117.216V115.016Z",
    fill: "#27DEBF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M111.027 115.016L112.384 111.21V113.85L111.027 117.216V115.016Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M112.383 111.21L106.099 110.455L104.595 114.254L111.027 115.016L112.383 111.21Z",
    fill: "#27DEBF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M112.383 111.21L106.099 110.455L104.595 114.254L111.027 115.016L112.383 111.21Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M105.424 113.711V102.982L110.455 103.576V114.305L105.424 113.711Z",
    fill: "#27DEBF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M105.424 113.711V102.982L110.455 103.576V114.305L105.424 113.711Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M110.455 103.576L111.562 100.496V111.577L110.455 114.305V103.576Z",
    fill: "#27DEBF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M110.455 103.576L111.562 100.496V111.577L110.455 114.305V103.576Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M111.562 100.496L106.634 99.9097L105.424 102.982L110.455 103.576L111.562 100.496Z",
    fill: "#27DEBF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M111.562 100.496L106.634 99.9097L105.424 102.982L110.455 103.576L111.562 100.496Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M106.993 102.293V96.4482L109.736 96.7709V102.616L106.993 102.293Z",
    fill: "#27DEBF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M106.993 102.293V96.4482L109.736 96.7709V102.616L106.993 102.293Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M109.736 96.7711L110.337 95.0918V101.134L109.736 102.616V96.7711Z",
    fill: "#27DEBF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M109.736 96.7711L110.337 95.0918V101.134L109.736 102.616V96.7711Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M110.337 95.0917L107.653 94.769L106.993 96.4484L109.736 96.7711L110.337 95.0917Z",
    fill: "#27DEBF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M110.337 95.0917L107.653 94.769L106.993 96.4484L109.736 96.7711L110.337 95.0917Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M136.107 131.883V114.979L141.145 115.574V132.477L136.107 131.883Z",
    fill: "#27DEBF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M136.107 131.883V114.979L141.145 115.574V132.477L136.107 131.883Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M141.145 115.574L141.878 113.418V130.673L141.145 132.477V115.574Z",
    fill: "#27DEBF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M141.145 115.574L141.878 113.418V130.673L141.145 132.477V115.574Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M141.878 113.418L136.957 112.831L136.107 114.98L141.145 115.574L141.878 113.418Z",
    fill: "#27DEBF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M141.878 113.418L136.957 112.831L136.107 114.98L141.145 115.574L141.878 113.418Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M144.254 137.273V121.624L148.639 122.115V137.765L144.254 137.273Z",
    fill: "#27DEBF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M144.254 137.273V121.624L148.639 122.115V137.765L144.254 137.273Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M148.639 122.115L149.629 119.468V135.66L148.639 137.764V122.115Z",
    fill: "#27DEBF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M148.639 122.115L149.629 119.468V135.66L148.639 137.764V122.115Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M149.629 119.468L145.413 118.984L144.254 121.624L148.639 122.115L149.629 119.468Z",
    fill: "#27DEBF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M149.629 119.468L145.413 118.984L144.254 121.624L148.639 122.115L149.629 119.468Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M149.138 136.826V122.694L151.463 122.944V137.075L149.138 136.826Z",
    fill: "#27DEBF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M149.138 136.826V122.694L151.463 122.944V137.075L149.138 136.826Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M151.463 122.944L151.822 121.785V136.378L151.463 137.075V122.944Z",
    fill: "#27DEBF"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M151.463 122.944L151.822 121.785V136.378L151.463 137.075V122.944Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M151.822 121.785L149.652 121.536L149.138 122.694L151.463 122.944L151.822 121.785Z",
    fill: "#27DEBF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M151.822 121.785L149.652 121.536L149.138 122.694L151.463 122.944L151.822 121.785Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4294 112.545L74.6461 112.919C74.8001 113.909 74.9541 114.899 75.1081 115.889C75.1741 116.314 75.3648 116.718 75.6654 117.033C76.1348 117.532 76.6921 117.957 77.2934 118.258C78.2614 118.727 79.1854 119.299 80.2194 119.651C80.7034 119.82 81.3928 120.084 81.1288 120.758C81.0408 120.986 80.7768 121.147 80.5421 121.088H72.7541C72.4314 121.088 72.0134 120.876 71.8374 120.612C71.6614 120.34 71.5808 120.018 71.5148 119.695C71.3241 118.786 71.1994 117.862 71.1334 116.938H71.1188L70.4294 112.552V112.545Z",
    fill: "#C1813E"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1382 121.11H80.6962C81.1728 121.11 81.4735 120.56 81.1875 120.179C80.7475 119.614 79.8382 119.35 79.2222 119.05C78.8922 118.888 78.5622 118.734 78.2102 118.646C77.8582 118.558 77.4768 118.551 77.1395 118.698C76.5602 118.94 76.1935 119.6 75.5775 119.732C75.1522 119.827 74.7048 119.636 74.3675 119.358C74.0302 119.086 73.7662 118.727 73.4728 118.404C73.2235 118.14 72.9522 117.898 72.6515 117.693C72.4682 117.561 72.2702 117.444 72.0502 117.385C71.8302 117.326 71.5808 117.341 71.3902 117.473C70.7888 117.876 71.5368 120.216 71.6322 120.692C71.6835 120.934 71.8962 121.11 72.1455 121.11H72.1382Z",
    fill: "#2D2D2D"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3261 113.066L62.4288 115.786C62.4508 116.366 62.7001 116.916 63.1254 117.319C63.5141 117.686 63.9468 118.001 64.4161 118.236C65.3768 118.72 66.3008 119.299 67.3274 119.666C67.8114 119.834 68.4934 120.113 68.2221 120.78C68.1268 121.008 67.8628 121.162 67.6281 121.103L59.8401 121.015C59.5174 121.015 59.0994 120.795 58.9308 120.524C58.7548 120.252 58.6814 119.922 58.6154 119.607C58.4981 118.998 58.4688 118.316 58.4541 117.649H58.4174L58.2561 112.442L62.3188 113.073L62.3261 113.066Z",
    fill: "#C1813E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2386 121.029L67.8773 121.132C68.2586 121.132 68.5446 120.751 68.398 120.399C68.3686 120.325 68.332 120.259 68.288 120.201C67.8553 119.636 66.9533 119.365 66.3373 119.057C66.0146 118.895 65.6846 118.734 65.3326 118.639C64.9806 118.551 64.5993 118.536 64.262 118.675C63.6753 118.917 63.3013 119.563 62.6853 119.687C62.26 119.775 61.8126 119.577 61.4826 119.299C61.1453 119.02 60.8886 118.661 60.5953 118.338C60.3533 118.074 60.082 117.825 59.7813 117.619C59.598 117.487 59.4 117.363 59.18 117.304C58.96 117.245 58.7106 117.26 58.52 117.385C57.9113 117.781 58.6373 120.127 58.7253 120.611C58.7693 120.853 58.982 121.037 59.2313 121.037L59.2386 121.029Z",
    fill: "#2D2D2D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8007 79.6843L75.8267 113.337H68.7941L66.0587 89.8702L63.7487 113.418H56.7234L58.7767 87.1276C58.9087 85.6389 59.0774 83.9816 59.2167 82.4929C59.2607 82.0236 59.3047 81.5469 59.3781 81.0776C59.4881 80.4176 59.6714 79.7722 59.9207 79.1562L71.7934 79.6769",
    fill: "#D7D8D6"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1567 64.7093L66.6527 61.4313C65.4354 60.0159 65.3474 57.9773 66.3887 56.4153C66.6674 55.99 67.0487 55.638 67.4521 55.3373C68.0607 54.89 68.7574 54.5453 69.5054 54.4206C70.2534 54.296 70.9574 54.1566 71.5147 54.67C72.1967 55.3006 72.6954 56.1146 73.0621 56.9653C73.4287 57.8233 73.6707 58.718 73.9201 59.62C73.9567 59.752 73.9861 59.8913 73.9201 60.0086C73.8174 60.192 73.5534 60.1773 73.3481 60.1406C73.3627 60.698 73.3774 61.2553 73.3921 61.8126C73.4067 62.5313 73.5241 63.6679 72.5121 63.7413H71.2287L69.7914 66.1246L65.1641 64.7093",
    fill: "#C1813E"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M72.116 58.3806C72.116 58.5053 72.2113 58.6153 72.336 58.6153C72.4606 58.6153 72.5706 58.52 72.5706 58.3953C72.5706 58.2706 72.4753 58.1606 72.3506 58.1606C72.226 58.1606 72.116 58.256 72.116 58.3806Z",
    fill: "#0E1010"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M73.106 60.6248C73.172 60.6101 73.0693 60.6248 73.0473 60.6248C72.9813 60.6248 72.9226 60.6248 72.8566 60.6248C72.6366 60.5954 72.4606 60.4781 72.3359 60.3021C72.2406 60.1701 72.0279 60.3168 72.1306 60.4561C72.3726 60.7934 72.7906 60.9621 73.2013 60.8668C73.3626 60.8301 73.2673 60.5881 73.106 60.6248Z",
    fill: "#8B5624"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5713 63.2427L70.7446 64.438L71.4266 63.3087L69.5713 63.2427Z",
    fill: "#B25E23"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0835 61.3362C65.0175 61.2042 64.9588 61.0868 64.9075 60.9695C64.4308 59.8622 64.3282 58.5935 64.6875 57.4348C65.3182 55.4548 67.2835 53.9735 69.3588 53.9222C69.8428 53.9075 70.3342 53.9662 70.8108 53.8562C71.3462 53.7315 71.9475 53.4088 72.3802 53.8122C72.5342 53.9588 72.6148 54.1715 72.6148 54.3915C72.6148 55.2422 72.0135 55.9095 71.2802 56.2395C70.8402 56.4375 70.3708 56.5255 69.8942 56.5915C69.5495 56.6355 69.3002 56.9288 69.3075 57.2735L69.3442 58.7622C69.3442 58.9455 69.1535 59.0628 68.9995 58.9748C68.6255 58.7695 68.1855 58.6815 67.8335 58.8722C67.5622 59.0188 67.3935 59.2975 67.3055 59.5982C67.0928 60.3608 67.4888 61.2408 68.2002 61.5855C68.2295 62.2235 68.1928 63.1988 67.3862 63.2575C66.3742 63.3308 65.5455 62.2382 65.0908 61.3435L65.0835 61.3362Z",
    fill: "#0E1010"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9386 53.5775C67.1806 55.3228 65.9633 56.9288 64.218 57.1708C62.4726 57.4128 60.8666 56.1955 60.6246 54.4502C60.3826 52.7048 61.6 51.0988 63.3453 50.8568C65.0906 50.6148 66.6966 51.8322 66.9386 53.5775Z",
    fill: "#0E1010"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0521 71.0381L75.9808 75.4088C76.0834 75.6434 76.3401 75.7608 76.5821 75.6948L85.1034 73.2894C85.3968 73.1281 85.5728 72.8788 85.8441 72.6881C86.4528 72.2554 87.1934 72.0647 87.9121 71.8814C88.0954 71.8374 88.2788 71.7861 88.4621 71.7494C88.6234 71.7127 88.8141 71.7201 88.9608 71.6467C88.9901 71.6321 89.0194 71.6174 89.0488 71.6174C89.1808 71.6174 89.1441 71.8448 89.1148 71.9181C89.0634 72.0428 88.9534 72.1528 88.8434 72.2334C88.5574 72.4314 88.2494 72.5854 87.9854 72.8054C87.8021 72.9594 87.5161 73.2161 87.7874 73.4141C88.0808 73.6341 88.6088 73.4801 88.9241 73.4141C89.1368 73.3701 89.3494 73.3041 89.5694 73.2967C89.7894 73.2894 90.0168 73.3408 90.1708 73.5021C90.3468 73.6781 90.3614 74.0521 90.3468 74.2868C90.3174 74.6314 89.9581 74.6168 89.7894 74.8514C89.7308 74.9394 89.7088 75.0494 89.6574 75.1374C89.5254 75.3501 89.2248 75.3868 89.0488 75.5628C88.9094 75.7021 88.8508 75.9368 88.6674 76.0101C88.2274 76.1934 87.5894 76.0761 87.1274 76.0541L75.8561 79.9847C75.0421 80.2708 74.1474 79.9188 73.7441 79.1561L69.8574 71.8081L74.0594 71.0381",
    fill: "#C1813E"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7694 65.2964C71.104 65.4944 72.2554 66.3377 72.842 67.555C72.842 67.555 75.1594 71.383 74.6534 72.7617C74.4627 73.2897 74.008 73.7297 73.4507 73.8104L72.0354 81.679L59.8914 81.393L61.8127 68.655C61.556 66.323 63.5727 64.3797 65.89 64.7244L69.7694 65.2964Z",
    fill: "url(#paint0_linear_31451_19976)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2434 84.9644C60.4414 85.2577 60.5954 85.573 60.7494 85.8884C60.9327 86.277 60.9914 86.5557 61.0134 86.9957C61.072 87.8537 61.094 88.7117 61.0794 89.577C61.0794 89.665 61.0647 89.7677 60.9914 89.8044C60.9254 89.841 60.8447 89.8044 60.786 89.7677C60.3974 89.5037 60.4707 88.8877 60.1774 88.5284C60.1407 88.4844 60.0967 88.4477 60.0454 88.4477C59.9794 88.4477 59.9427 88.521 59.9207 88.587C59.752 89.115 60.0087 89.8264 60.17 90.3324C60.302 90.7504 60.6834 91.953 60.1114 92.2537C59.7594 92.437 59.114 92.0557 58.8207 91.909C56.4887 90.7064 56.9434 87.2744 57.354 85.177",
    fill: "#C1813E"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0088 70.9355L65.8755 71.8962L61.8275 77.5649L60.1555 86.2695L57.2295 86.4089L57.7355 77.5795C57.7575 77.2055 57.8382 76.8389 57.9702 76.4869L60.0015 70.9429",
    fill: "#C1813E"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7107 73.172L65.208 74.4333L67.166 69.1753C67.9874 66.9753 66.3007 64.6433 63.9467 64.7387C62.59 64.7973 61.402 65.6773 60.962 66.968L58.7034 73.172",
    fill: "#F4B01A"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0934 64.7388C64.2694 64.7388 64.4454 64.7534 64.614 64.7828C66.22 65.0394 67.386 66.4474 67.3787 68.0314C67.3787 68.4128 67.3127 68.7941 67.166 69.1828L65.208 74.4408L58.7107 73.1794L60.9694 66.9754C61.4094 65.6848 62.59 64.8048 63.954 64.7461C63.998 64.7461 64.0494 64.7461 64.0934 64.7461",
    fill: "url(#paint1_linear_31451_19976)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M68.222 61.8717C68.3556 61.8717 68.464 61.7633 68.464 61.6297C68.464 61.496 68.3556 61.3877 68.222 61.3877C68.0883 61.3877 67.98 61.496 67.98 61.6297C67.98 61.7633 68.0883 61.8717 68.222 61.8717Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6748 75.9297L87.0101 73.8177C86.8415 73.5977 86.8268 73.2604 86.9881 72.9817L89.7968 68.061C90.0461 67.621 90.5741 67.5404 90.8308 67.8924L92.4368 70.107C92.5981 70.327 92.5981 70.657 92.4368 70.9284L89.6795 75.739C89.4375 76.1644 88.9241 76.2597 88.6601 75.9297",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2954 68.3765C90.1194 68.3765 89.9288 68.4791 89.8188 68.6771L87.6188 72.5198C87.5601 72.6225 87.5308 72.7325 87.5308 72.8425C87.5308 72.9671 87.5674 73.0845 87.6408 73.1725L88.9754 74.8445C89.0634 74.9545 89.1808 75.0058 89.3128 75.0058C89.4888 75.0058 89.6794 74.9031 89.7894 74.7051L91.9454 70.9431C92.0041 70.8405 92.0334 70.7305 92.0334 70.6205C92.0334 70.5031 91.9968 70.3931 91.9308 70.3051L90.6401 68.5525C90.5521 68.4351 90.4274 68.3765 90.2954 68.3765Z",
    fill: "#95EFC6"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0294 74.7636H88.0074C87.9194 74.749 87.8534 74.6463 87.8534 74.4996C87.8534 74.463 87.8534 74.4336 87.868 74.397C87.9047 74.221 88.0294 74.089 88.132 74.089H88.154C88.242 74.1036 88.308 74.2063 88.308 74.353C88.308 74.3896 88.308 74.4263 88.2934 74.463C88.2567 74.639 88.132 74.771 88.0294 74.771M88.132 74.0156C87.978 74.0156 87.8387 74.177 87.7947 74.375C87.7874 74.419 87.78 74.4556 87.78 74.4996C87.78 74.661 87.8534 74.8076 87.9927 74.837H88.0294C88.1834 74.837 88.3227 74.683 88.3667 74.4776C88.374 74.4336 88.3814 74.397 88.3814 74.353C88.3814 74.1916 88.308 74.045 88.1687 74.023H88.132",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M89.606 69.0508L89.166 69.8208L90.596 73.3041L91.2854 72.0941L89.606 69.0508Z",
    fill: "#BBF9DC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7847 70.4954L88.5647 70.8694L90.1854 74.0154L90.3467 73.7367L88.8947 70.2974",
    fill: "#BBF9DC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0734 47.1241C99.0734 52.1401 89.9947 65.3621 89.9947 65.3621C89.9947 65.3621 80.916 52.1327 80.916 47.1241C80.916 42.1154 84.9787 38.0454 89.9947 38.0454C95.0107 38.0454 99.0734 42.1081 99.0734 47.1241Z",
    fill: "#04A344"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9948 50.996C92.352 50.996 94.2628 49.0851 94.2628 46.728C94.2628 44.3708 92.352 42.46 89.9948 42.46C87.6377 42.46 85.7268 44.3708 85.7268 46.728C85.7268 49.0851 87.6377 50.996 89.9948 50.996Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4707 47.9235C82.4707 43.5675 85.998 40.0401 90.354 40.0401C92.8987 40.0401 95.1647 41.2501 96.602 43.1201C95.238 40.7588 92.686 39.1675 89.7674 39.1675C85.4114 39.1675 81.884 42.6948 81.884 47.0508C81.884 48.8621 82.4927 50.5268 83.5194 51.8541C82.852 50.6955 82.4707 49.3535 82.4707 47.9235Z",
    fill: "#8BEF8F"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8533 61.8933C89.0926 63.9687 89.9946 65.362 89.9946 65.362C89.9946 65.362 99.0733 52.1327 99.0733 47.124C99.0733 46.86 99.0586 46.6033 99.0366 46.3467C98.6773 47.74 98.1713 49.0967 97.5479 50.3873C95.8319 53.966 93.2873 56.254 90.5813 59.158C89.7086 60.0967 88.7993 61.0207 87.8533 61.8933Z",
    fill: "#02963E"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5401 49.9182C89.5401 49.9182 89.5107 49.9182 89.4961 49.9182C89.0707 49.9036 88.6747 49.6836 88.4474 49.3169C87.0101 47.0656 84.4948 44.9682 84.4728 44.9462C83.9228 44.4916 83.8421 43.6702 84.3041 43.1202C84.7587 42.5702 85.5801 42.4896 86.1301 42.9516C86.2254 43.0322 88.0441 44.5429 89.6134 46.5082C91.2047 44.7116 94.5048 41.3822 99.6674 38.0676C100.269 37.6789 101.075 37.8549 101.457 38.4562C101.845 39.0576 101.669 39.8642 101.068 40.2456C94.0648 44.7482 90.6254 49.3462 90.5887 49.3902C90.3467 49.7202 89.9581 49.9182 89.5474 49.9182H89.5401Z",
    fill: "#04A344",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31451_19976",
    x1: 74.734,
    y1: 73.187,
    x2: 59.8987,
    y2: 73.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31451_19976",
    x1: 68.4473,
    y1: 68.8922,
    x2: 60.6982,
    y2: 67.7286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWomanLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/woman-location.460b91eaf29919e7b7264c9f7690d214.svg";